import './feature-slider.scss'
import Vue from 'vue'

export default {
    name: 'feature-slider',

    data: {
        index: 0,
        interactions: true,
        state: 'in' // in, out
    },

    computed: {
        currentSlide () {
            if (this.slides && this.slides.length && this.slides[this.index]) {
                return this.slides[this.index]
            } else {
                return null
            }
        },

        nextIndex () {
            const nextIndex = (this.index + 1 === this.slides.length) ? 0 : this.index + 1
            return (nextIndex !== this.index) ? nextIndex : null
        }
    },

    methods: {
        toggleSlide (i) {
            if (!this.interactions) {
                return
            }
            if (i === this.index) {
                return
            }

            this.interactions = false

            Promise.resolve()
                .then(() => new Promise(resolve => {
                    this.state = 'out'
                    setTimeout(() => resolve(), 550)
                }))
                .then(() => new Promise(resolve => {
                    this.index = i
                    Vue.nextTick(() => resolve())
                }))
                .then(() => new Promise(resolve => {
                    this.state = 'in'
                    setTimeout(() => resolve(), 550)
                }))
                .then(() => {
                    this.interactions = true
                })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/feature-slider/feature-slider.js